import { Box, Grid, Typography, useTheme } from '@mui/material'

interface ItemDetailsBoxProps {
  boxTitle: string
  firstFieldTitle: string
  firstFieldText: string | number
  secondFieldTitle: string
  secondFieldText: string | number
}

export const ItemDetailsBox = ({
  boxTitle,
  firstFieldTitle,
  firstFieldText,
  secondFieldTitle,
  secondFieldText,
}: ItemDetailsBoxProps) => {
  const theme = useTheme()

  return (
    <>
      <Typography variant="h2" pb={2}>
        {boxTitle}
      </Typography>
      <Box
        border={{ md: `1px solid ${theme.palette.grey[200]}` }}
        borderRadius={'5px'}
        p={{ xs: 0, sm: 3 }}
      >
        <Grid container className="flex flex-row flex-wrap" columnGap={24}>
          <Grid item sm={8} md={4} lg={4}>
            <Box>
              <Typography variant="body2" pb={1} color="text.secondary">
                {firstFieldTitle}
              </Typography>
              <Typography variant="body1" pb={2}>
                {firstFieldText}
              </Typography>
            </Box>
          </Grid>
          <Grid item sm={8} md={4} lg={4}>
            <Box>
              <Typography variant="body2" pb={1} color="text.secondary">
                {secondFieldTitle}
              </Typography>
              <Typography variant="body1">{`#${secondFieldText}`}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
